/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import Img from 'react-image';

import CircularProgress from '@mui/material/CircularProgress';

import { buildThumbnailURL, fetchEntityAsBase64 } from '../../services/ThumbnailApiService';
import { ThumbnailOption } from '../../types/thumbnail/ThumbnailOption';
import { useThumbnailSelectorItemStyles } from './ThumbnailSelector.styles';
import { ThumbnailSelectorType } from './ThumbnailSelector.types';

type ThumbnailSelectorItemProps = {
  option: ThumbnailOption;
  onClick: (value: ThumbnailOption) => any;
  isActive?: boolean;
  type: ThumbnailSelectorType;
};

export function ThumbnailSelectorItem(props: ThumbnailSelectorItemProps) {
  const classes = useThumbnailSelectorItemStyles();
  const { option, onClick, isActive, type } = props;
  const { type: optionType } = option;

  const [imageSrc, setImageSrc] = useState<string>();

  useEffect(() => {
    if (optionType === 'seed' && option.seed) {
      switch (type) {
        case ThumbnailSelectorType.organization:
          void fetchEntityAsBase64(buildThumbnailURL('organization', btoa(option.seed), 48)).then(res =>
            setImageSrc(res),
          );
          break;
        case ThumbnailSelectorType.user:
          void fetchEntityAsBase64(buildThumbnailURL('user', btoa(option.seed), 48)).then(res => setImageSrc(res));
          break;
        case ThumbnailSelectorType.project:
          void fetchEntityAsBase64(buildThumbnailURL('project', btoa(option.seed), 48)).then(res => setImageSrc(res));
          break;
      }
    } else if (optionType === 'base64' && option.base64) {
      setImageSrc(option.base64);
    }
  }, [optionType, option, type]);

  return (
    <div className={cx(classes.root, { [classes.active]: isActive })}>
      <div className={classes.content} onClick={() => onClick(option)}>
        {imageSrc === null ? (
          // this should never happen
          <CircularProgress color="primary" size={30} />
        ) : (
          <Img src={imageSrc} loader={<CircularProgress color="primary" size={30} />} />
        )}
        <div className={classes.activeCorner} />
      </div>
    </div>
  );
}
